export function getDisabledUserRedirectUrl(apiBase) {
    const normalizedBase = String(apiBase || '').replace(/\/+$/, '');
    return `${normalizedBase}/disabilitato`;
}

export function isUserDisabled(userData) {
    return Number(userData?.disabled) === 1;
}

export function redirectDisabledUser(apiBase) {
    sessionStorage.removeItem('loggedUser');
    window.location.replace(getDisabledUserRedirectUrl(apiBase));
}
